import React, { useState } from "react";

function FileUpload(props) {
  const { field, form } = props;

  const maxFileSize = 50; // max file size in KB
  const [error, setError] = useState();

  const isImage = file => {
    // return ["jpg", "png", "svg", "jpeg", "gif", "bmp"].includes(file.name.split(".")[1]);
    return ["jpg", "png", "jpeg"].includes(file.name.split(".").pop());
  };
  const isTooBig = file => file.size > maxFileSize * 1024;

  const handleChange = e => {
    setError(null);
    const file = e.currentTarget.files[0];
    if (!isImage(file)) return setError("Die Datei ist kein Image");
    if (isTooBig(file)) return setError(`Die Dateigröße darf ${maxFileSize} KB nicht überschreiten`);
    const reader = new FileReader();
    const imgTag = document.getElementById("myimage");
    imgTag.title = file.name;
    reader.onload = function (event) {
      // imgTag.src = event.target.result;
      form.setFieldValue(field.name, event.target.result);
    };
    reader.readAsDataURL(file);
  };

  const deleteChoice = e => {
    let confirm = window.confirm("Sind Sie sicher?");
    if (confirm) form.setFieldValue(field.name, "");
  }

  return (
    <div className="field fileWithPreview">
      <div className="file">
        <label className="file-label">
          <input type={"file"} onChange={o => handleChange(o)} className={"file-input"} accept="image/*" />
          <span className="file-cta">
            <span className="file-icon">
              <i className="fas fa-upload"></i>
            </span>
            <span className="file-label">Bilddatei wählen</span>
          </span>
        </label>
        {Boolean(field.value) && (
        <button className="button is-danger" onClick={deleteChoice}>
          <span className="icon is-small">
            <i className="fas fa-trash-alt"></i>
          </span>
          <span>Auswahl löschen</span>
        </button>
      )}
      </div>
      <div className="file-preview">
        <img src={field.value} alt="" id={"myimage"} />
      </div>
      {error && <p>{error}</p>}
    </div>
  );
}

export default FileUpload;
